import { useEffect, useRef, useState } from 'react';

import Container from './Container';
import { useReveal } from '../../../hooks/useReveal';

const STATS = [
  { value: 3.5, decimals: 1, suffix: 'M', label: 'Students Worldwide' },
  { value: 5, decimals: 0, suffix: '', label: 'AI-Powered Study Tools' },
  { value: 100, decimals: 0, suffix: '%', label: 'Currenlty Free' },
  { value: 50, decimals: 0, suffix: '+', label: 'Partner Universities' },
];

const CountUp = ({ value, decimals, suffix, start }) => {
  const [display, setDisplay] = useState(0);
  const raf = useRef(0);

  useEffect(() => {
    if (!start) return;
    const duration = 1400;
    let startTime;
    const tick = (t) => {
      if (!startTime) startTime = t;
      const p = Math.min((t - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(value * eased);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [start, value]);

  return (
    <span>
      {display.toFixed(decimals)}
      {suffix}
    </span>
  );
};

const Stats = () => {
  const { ref, visible } = useReveal({ threshold: 0.3 });

  return (
    <section className="relative py-6 lg:py-10">
      <Container>
        <div
          ref={ref}
          className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4"
        >
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className="glass glass-hover reveal flex flex-col items-center gap-2 rounded-2xl px-4 py-7 text-center md:py-8"
              style={{
                transitionDelay: `${i * 90}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? 'none' : 'translateY(30px)',
              }}
            >
              <div className="font-heading text-[2rem] font-bold text-white md:text-[2.5rem]">
                <CountUp {...s} start={visible} />
              </div>
              <div className="text-[0.85rem] text-white/50">{s.label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Stats;
